// extracted by mini-css-extract-plugin
export var center = "aligned-block-module--center--510bf";
export var fullWidth = "aligned-block-module--fullWidth--3461c";
export var left = "aligned-block-module--left--25765";
export var wrapper = "aligned-block-module--wrapper--8e550";